<div class="card pad-15 other-skills">
  <span class="skill-chip" *ngFor="let skill of skills | slice:0:displayNumber">{{skill['name']}}</span>
  <span class="skill-chip skill-chip-more" *ngIf="moreSkills > 0" (click)="open()">+{{moreSkills}}</span>
</div>
